export const PublicAppUrl = {
  Development: 'https://dev.commo.sankarah.com',
  Localhost: 'http://localhost:4200',
  Production: 'https://commo.sankarah.com',
} as const;

export type PublicAppUrl = (typeof PublicAppUrl)[keyof typeof PublicAppUrl];
